/** Weekday `weekday`'s name, Monday's 0, in `language`: from the 1st of
 * January 2001, a Monday. */
export const WeekdayName = (weekday: number, language: string): string =>
  new Intl.DateTimeFormat(language, { timeZone: "UTC", weekday: "long" }).format(
    Date.UTC(2001, 0, 1 + weekday)
  )
